import React from 'react';
import { motion } from 'framer-motion';
import { Shield, Star, Heart, Search } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
export const About = () => {
  const {
    t
  } = useLanguage();
  const fadeInUp = {
    hidden: {
      opacity: 0,
      y: 30
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6
      }
    }
  };
  const values = [{
    icon: Shield,
    title: t('about.values.trust'),
    desc: t('about.values.trustDesc')
  }, {
    icon: Star,
    title: t('about.values.quality'),
    desc: t('about.values.qualityDesc')
  }, {
    icon: Heart,
    title: t('about.values.care'),
    desc: t('about.values.careDesc')
  }, {
    icon: Search,
    title: t('about.values.detail'),
    desc: t('about.values.detailDesc')
  }];
  return <div className="w-full bg-white pt-32 pb-20" data-id="element-118">
      {/* Header */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center mb-20" data-id="element-119">
        <motion.div initial="hidden" animate="visible" variants={fadeInUp} data-id="element-120">
          <h2 className="text-4xl font-script text-pink-primary mb-2" data-id="element-121">Lucy</h2>
          <h1 className="text-4xl md:text-5xl font-bold text-navy mb-6" data-id="element-122">
            {t('about.title')}
          </h1>
        </motion.div>
      </div>

      {/* Story Section */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mb-24" data-id="element-123">
        <div className="flex flex-col lg:flex-row gap-16 items-center" data-id="element-124">
          <motion.div initial="hidden" whileInView="visible" viewport={{
          once: true
        }} variants={fadeInUp} className="lg:w-1/2" data-id="element-125">
            <div className="relative" data-id="element-126">
              <div className="aspect-square rounded-full overflow-hidden relative shadow-2xl bg-white border-4 border-pink-light" data-id="element-127">
                <img src="https://cdn.magicpatterns.com/uploads/wpMMhZ6cjW78uSbr2ffzRh/ChatGPT_Image_May_30,_2026,_09_27_12_AM.png" alt="Lucy Cleaning Services - Clean Spaces, Happy Faces" className="w-full h-full object-contain" data-id="element-128" />
              </div>

              {/* Decorative sparkle */}
              <div className="absolute -bottom-4 -right-4 w-20 h-20 bg-pink-primary rounded-full shadow-lg flex items-center justify-center text-white" data-id="element-129">
                <Heart className="w-8 h-8 fill-current" data-id="element-130" />
              </div>
            </div>
          </motion.div>

          <motion.div initial="hidden" whileInView="visible" viewport={{
          once: true
        }} variants={fadeInUp} className="lg:w-1/2 space-y-8" data-id="element-131">
            <div data-id="element-132">
              <h3 className="text-3xl font-bold text-navy mb-6" data-id="element-133">
                {t('about.storyTitle')}
              </h3>
              <p className="text-lg text-gray-600 leading-relaxed mb-6" data-id="element-134">
                {t('about.story')}
              </p>
              <p className="text-lg text-gray-600 leading-relaxed" data-id="element-135">
                {t('about.mission')}
              </p>
            </div>
          </motion.div>
        </div>
      </div>
      {/* Values Section */}
      <div className="bg-pink-lighter/50 py-24" data-id="element-136">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-137">
          <motion.div initial="hidden" whileInView="visible" viewport={{
          once: true
        }} variants={fadeInUp} className="text-center mb-16" data-id="element-138">
            <h3 className="text-3xl font-bold text-navy" data-id="element-139">
              {t('about.values.title')}
            </h3>
          </motion.div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-140">
            {values.map((value, idx) => <motion.div key={idx} initial="hidden" whileInView="visible" viewport={{
            once: true
          }} variants={fadeInUp} transition={{
            delay: idx * 0.1
          }} className="bg-white p-8 rounded-3xl shadow-sm border border-pink-50 text-center hover:shadow-pink-soft transition-shadow" data-id="element-141">
                <div className="w-16 h-16 bg-pink-lighter rounded-full flex items-center justify-center text-pink-primary mx-auto mb-6" data-id="element-142">
                  <value.icon className="w-8 h-8" data-id="element-143" />
                </div>
                <h4 className="text-xl font-bold text-navy mb-3" data-id="element-144">
                  {value.title}
                </h4>
                <p className="text-gray-600" data-id="element-145">{value.desc}</p>
              </motion.div>)}
          </div>
        </div>
      </div>
    </div>;
};